package org.chiangmeng.qfast.core.domain.models

// Data model representing queue ticket details
data class QueueTicket(
    val number: Int,
    val category: String,
    val status: String,
    val time: String,
    val callTime: String? = null,
    val preOrder: String? = null
)
